export const NOTIFICATION_EVENTS = '/admin/app/notification-events';
export const NOTIFICATION_TEMPLATES = '/admin/app/notification-templates';

export const DEFAULT_DASHBOARD_INFO = 'default-dashboard-info';
export const AUDIENCE_OVERVIEW_CHART = 'audience-overview-chart';
export const BROWSER_OVERVIEW_CHART = 'browser-overview-chart';

//Profile
export const MY_PROFILE = '/my-profile';
export const All_NOTIFICATION = '/all-notifications';
export const LOGOUT = '/admin/log-out';

//app setting view
export const APP_SETTINGS = '/app-setting';
export const GENERAL_SETTINGS = 'general-settings';

//reCAPTCHA
export const GET_RECAPTCHA_SETTINGS = '/get-re-captcha-setting';
//Sms settings
export const GET_SMS_SETTINGS_INFO = 'get-sms-setting-info';
//Email settings
export const GET_EMAIL_SETTINGS = '/admin/app/settings/delivery-settings';

//roles and users
export const ROLES = 'admin/auth/roles';
export const USERS = 'admin/auth/users';
export const USERS_LIST = 'user-list';
export const GET_USERS = 'get/users';
export const GET_STATUSES = 'admin/app/statuses';
export const INVITE_USER = '/admin/auth/users/invite-user';
export const DETACH_ROLES = 'admin/auth/users/detach-roles/';
export const UPDATE_USER_NAME = '/update-user-name/';

//Notification
export const NOTIFICATIONS = '/admin/user/notifications';
export const LOGIN_USER = '/login-user';

// Language
export const LANGUAGE = 'languages';
export const BASIC_SETTINGS = '/get-basic-setting-data';

// Social links
export const CHANGE_SOCIAL_LINKS = '/change-social-link';

export const CATEGORIES = 'admin/categories';
export const SELECTABLE_MAIN_CATEGORIES = 'admin/selectable/main-categories';
export const SELECTABLE_ICONS = 'select-able/icon-classes';
export const SELECTABLE_CATEGORIES = 'admin/selectable/categories';
export const BRANDS = 'admin/brands';
export const SELECTABLE_BRANDS = 'admin/selectable/brands';
export const PRODUCTS = 'admin/products';
export const ORDERS = 'admin/orders';
export const PRODUCT_LIST = 'admin/products/list';
export const AREAS = 'sadfsdag';
export const THANAS = 'admin/thanas';
export const DISTRICTS = 'admin/districts';
export const CONTACT_US = 'admin/api/contact-us';
export const FAQS = 'admin/faqs';
export const BANNERS = 'admin/banners';
export const EARNERS = 'admin/earners';